import { sidebarMenuMobileIsOpen } from "../state";

export function sidebarMethodToggleMenuMobile(): void {
  const body = document.body.style;
  const menuMobile = sidebarMenuMobileIsOpen;

  menuMobile.value ? (body.overflow = "") : (body.overflow = "hidden");
  menuMobile.value = !menuMobile.value;
}
